import { NavItemEnum } from '../constants/routing/NavItems';
export const productLineToNavItemMap = {
  CMS: NavItemEnum.CONTENT,
  MARKETING: NavItemEnum.MARKETING,
  OPERATIONS: NavItemEnum.DATA,
  SALES: NavItemEnum.SALES,
  SERVICE: NavItemEnum.SERVICE,
  COMMERCE: NavItemEnum.COMMERCE
};
export const getNavItemForProductLine = productLine => {
  return productLineToNavItemMap[productLine];
};
export const getProductLineForNavItem = navItem => {
  switch (navItem) {
    case NavItemEnum.MARKETING:
      return 'MARKETING';
    case NavItemEnum.SALES:
      return 'SALES';
    case NavItemEnum.SERVICE:
      return 'SERVICE';
    case NavItemEnum.CONTENT:
      return 'CMS';
    case NavItemEnum.DATA:
      return 'OPERATIONS';
    case NavItemEnum.COMMERCE:
      return 'COMMERCE';
    default:
      return null;
  }
};